var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDatenschutz = function SvgDatenschutz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 252.103 313.715"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "datenschutz_svg__a",
    x1: 7.851,
    x2: 233.542,
    y1: 214.108,
    y2: 53.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcc8cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d8dee2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "datenschutz_svg__b",
    x1: 38.737,
    x2: 207.403,
    y1: 152.789,
    y2: 153.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01b2c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a1b2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#datenschutz_svg__a)",
    d: "M126.051 313.715s62.51-52.89 84.885-79.366c31.932-37.752 47.836-152.035 38.53-200.523L126.05 0 2.637 33.864c-9.306 48.45 6.598 162.733 38.53 200.485 22.375 26.476 84.884 79.366 84.884 79.366"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a1b2",
    d: "M123.922 283.634c-18.829-16.499-52.494-46.626-66.418-63.052-23.026-27.233-39.137-116.37-35.687-167.534l.154-2.29 104.08-28.572L230.13 50.72l.155 2.29c3.45 51.157-12.66 140.288-35.685 167.517-14.864 17.59-51.405 49.994-66.426 63.11l-2.127 1.857Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#datenschutz_svg__b)",
    d: "M126.051 281.206c-21.472-18.813-52.814-47.058-66.084-62.71-22.575-26.703-38.278-115.55-34.93-165.23l101.014-27.73 101.014 27.693c3.349 49.679-12.366 138.527-34.93 165.216-13.281 15.715-44.612 44.01-66.084 62.76"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4f4f8",
    d: "m60.629 224.13-.537-.594a144 144 0 0 1-2.588-2.954c-23.026-27.233-39.137-116.37-35.687-167.534l.154-2.29 99.553-27.33L21.33 48.423l-1.659.456-.116 1.716-.154 2.29c-3.48 51.595 12.893 141.632 36.254 169.26C60.418 227.765 77.153 241 77.153 241c-6.331-6.124-12.06-11.932-16.524-16.868"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4f4f8",
    d: "M164.542 131.895h-6.311v-9.56a30.411 30.411 0 0 0-60.822 0v9.56h-6.312a5.48 5.48 0 0 0-5.485 5.485v46.49a5.49 5.49 0 0 0 5.485 5.485h73.445a5.48 5.48 0 0 0 5.485-5.485v-46.49a5.467 5.467 0 0 0-5.485-5.485m-29.002 43.447h-15.422l4.415-14.632a7.72 7.72 0 1 1 6.574 0Zm11.42-43.447h-38.28v-9.56a19.14 19.14 0 0 1 38.28 0Z"
  }))));
};
export default SvgDatenschutz;